/** Подписи ролей как в `frontend/src/components/Layout.js` */
export function getRoleLabel(role: string | null | undefined): string {
  const labels: Record<string, string> = {
    owner: 'Владелец',
    admin: 'Администратор',
    operator: 'Оператор',
    trainee: 'Стажер',
    shift_lead: 'Старший смены',
    npc_helper: 'NPC Helper',
    human_helper: 'Human Helper',
    analyst: 'Аналитик',
    viewer: 'Наблюдатель',
  }
  return labels[role || ''] || 'Оператор'
}
